// Get Page
export const setLocation = ({page = ''}) => {
  return {
    type: 'SET_LOCATION',
    location: {
      page
    }
  }
};